export const timeIn = seconds => seconds === null ? null : new Date(new Date().getTime() + seconds * 1000);
